/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import { useForm } from "react-hook-form"

import Menu from '../../../../components/CustomerClub/Menu'

import { get, put, deleteItem } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router'

export default function index() {
  const navigate = useNavigate()
  const { id } = useParams()

  // eslint-disable-next-line no-unused-vars
  const [user, setUser] = useState('')
  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  document.title = 'مشتری'

  const { register, handleSubmit, reset } = useForm()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/ccusers/${id}?token=${token}`)
      .then(response => {
        setUser(response.data.data[0])
        let defaultValues = {}
        defaultValues.name = response.data.data[0].name
        defaultValues.phoneNumber = response.data.data[0].phoneNumber
        defaultValues.email = response.data.data[0].email
        reset({ ...defaultValues })
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

  }, [id, reset, token])

  const deleteHandler = (e) => {
    deleteItem(`/api//admin/ccusers/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/cc/users')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  const onSubmit = (data, e) => {
    e.preventDefault()
    put(`/api/admin/ccusers/${id}?token=${token}`, {
      name: data.name,
      phoneNumber: data.phoneNumber,
      email: data.email
    }).then(response => {
      notify('success', response.data.messageFa)
      setTimeout(() => {
        navigate('/cc/users')
      }, 2000)
    }).catch(error => {
      notify('error', 'خطا در ارسال اطلاعات')
    })
  }
  
  return (
    <main id='panel'>
      <ToastContainer rtl />
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید مشتری مورد نظر حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <Menu page={'user'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text' >
                <div>
                  ویرایش مشخصات مشتری
                </div>
                
              </div>
            </div>
            <div className='left'>
              <div>
                <button onClick={e => { 
                  setCover(true)
                  setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'>حذف مشتری</button>
              </div>
            </div>
          </div>
          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * اطلاعات کاربر فقط جهت نمایش است. برای غیرفعال کردن کاربر جهت عدم دسترسی به اپلیکیشن از سوییچ بالا استفاده کنید.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات کاربر
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام :</label>
                <input id='foodName' {...register("name", { required: true, minLength: 3 })} type='text' placeholder='' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>شماره موبایل :</label>
                <input id='foodPrice' {...register("phoneNumber", { required: true, minLength: 11 })} className='ltrdirection' type='text' placeholder='25...' />
                <small id='foodPriceAlert'>قیمت باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>آدرس ایمیل :</label>
                <input id='foodLeveleDetails' className='ltrdirection' {...register("email", {  })} type='text' />
                <small id='foodLeveleDetailsAlert'>اولویت باید وارد شود</small>
              </div>
            </div>
            <button className='createButton'>آپدیت مشتری</button>
          </form>

          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
